import { useMemo } from 'react';

import type { ColGroupDef } from 'ag-grid-enterprise';

import type { SeedCount } from '@enterprise/api';

import NumberCellRenderer from '@components/grid/renderers/number-cell.renderer';
import TotalCellRenderer from '@components/grid/renderers/total-cell-renderer';

export const useGetSeedCountColumns = () => {
  return useMemo(() => {
    return [
      {
        children: [
          {
            field: 'mailingId',
            headerName: 'Mailing ID',
            hide: true,
          },
        ],
        headerClass: ['bg-blue-950'],
        headerName: 'Mailing and List Information',
      },
      {
        children: [
          {
            cellRenderer: TotalCellRenderer,
            field: 'fileName',
            headerName: 'File',
          },
          {
            cellDataType: 'date',
            field: 'fileLoadDate',
            headerName: 'Load Date',
          },
          {
            aggFunc: 'sum',
            cellRenderer: NumberCellRenderer,
            field: 'quantityFileCount',
            headerName: 'Size',
          },
        ],
        headerClass: ['bg-green-900'],
        headerGroupComponentParams: {
          icon: 'fa-user-plus',
        },
        headerName: 'Seed Information',
      },
    ] as ColGroupDef<SeedCount>[];
  }, []);
};
